import { merge } from 'lodash';
import Form from './Form';
export default function ComponentsOverrides({ theme }) {
  return merge(Form({ theme }));
}
